import { useParams } from "react-router";

export const useParamId = () => {
  const { id } = useParams();

  return {
    id: id ? Number(id) : undefined,
  };
};
